import { Posto } from "../posto/posto.model";

export class MaquinaCartao{
    id:number;
    descricao:string;
    marca:string;
    modelo:string;
    numeroSerie:string;
    posto:Posto;
}